import React from "react";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";

import BannerSection from "../../components/InnerPageBanner/InnerPageBanner.js";
import ArticlesList from "./Sections/ArticlesList.js";

import imgPath from "assets/img/windmill-2.jpg";

export default function ArtigosPage(props) {
  const { ...rest } = props;

  return (
    <div>
      <Header rightLinks={<HeaderLinks />} fixed color="white" {...rest} />

      <BannerSection
        title="Artigos"
        imgPath={imgPath}
        size="cover"
        position="center"
      />

      <ArticlesList />

      <Footer />
    </div>
  );
}
